@if (icon) {
<lucide-angular [img]="icon" [size]="size" [color]="color" [strokeWidth]="strokeWidth" class="icon"
  [class.icon--filled]="filled" />
}